!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("VueToast", [], e) : "object" == typeof exports ? exports.VueToast = e() : t.VueToast = e();
}(this, () => (() => {
  "use strict";

  var t = {
    d: (e, s) => {
      for (var o in s) t.o(s, o) && !t.o(e, o) && Object.defineProperty(e, o, {
        enumerable: !0,
        get: s[o]
      });
    },
    o: (t, e) => Object.prototype.hasOwnProperty.call(t, e)
  },
      e = {};
  t.d(e, {
    default: () => l
  });

  class s {
    constructor(t, e) {
      this.startedAt = Date.now(), this.callback = t, this.delay = e, this.timer = setTimeout(t, e);
    }

    pause() {
      this.stop(), this.delay -= Date.now() - this.startedAt;
    }

    resume() {
      this.stop(), this.startedAt = Date.now(), this.timer = setTimeout(this.callback, this.delay);
    }

    stop() {
      clearTimeout(this.timer);
    }

  }

  const o = Object.freeze({
    TOP_RIGHT: "top-right",
    TOP: "top",
    TOP_LEFT: "top-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM: "bottom",
    BOTTOM_LEFT: "bottom-left"
  });
  const i = {
    all: n = n || new Map(),
    on: function (t, e) {
      var s = n.get(t);
      s ? s.push(e) : n.set(t, [e]);
    },
    off: function (t, e) {
      var s = n.get(t);
      s && (e ? s.splice(s.indexOf(e) >>> 0, 1) : n.set(t, []));
    },
    emit: function (t, e) {
      var s = n.get(t);
      s && s.slice().map(function (t) {
        t(e);
      }), (s = n.get("*")) && s.slice().map(function (s) {
        s(t, e);
      });
    }
  };
  var n;

  var a = function (t, e, s, o, i, n, a, r) {
    var c,
        l = "function" == typeof t ? t.options : t;
    if (e && (l.render = e, l.staticRenderFns = s, l._compiled = !0), o && (l.functional = !0), n && (l._scopeId = "data-v-" + n), a ? (c = function (t) {
      (t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), i && i.call(this, t), t && t._registeredComponents && t._registeredComponents.add(a);
    }, l._ssrRegister = c) : i && (c = r ? function () {
      i.call(this, (l.functional ? this.parent : this).$root.$options.shadowRoot);
    } : i), c) if (l.functional) {
      l._injectStyles = c;
      var u = l.render;

      l.render = function (t, e) {
        return c.call(e), u(t, e);
      };
    } else {
      var p = l.beforeCreate;
      l.beforeCreate = p ? [].concat(p, c) : [c];
    }
    return {
      exports: t,
      options: l
    };
  }({
    name: "toast",
    props: {
      message: {
        type: String,
        required: !0
      },
      type: {
        type: String,
        default: "success"
      },
      position: {
        type: String,
        default: o.BOTTOM_RIGHT,
        validator: t => Object.values(o).includes(t)
      },
      duration: {
        type: Number,
        default: 3e3
      },
      dismissible: {
        type: Boolean,
        default: !0
      },
      onDismiss: {
        type: Function,
        default: () => {}
      },
      onClick: {
        type: Function,
        default: () => {}
      },
      queue: Boolean,
      pauseOnHover: {
        type: Boolean,
        default: !0
      }
    },
    data: () => ({
      isActive: !1,
      parentTop: null,
      parentBottom: null,
      isHovered: !1
    }),

    beforeMount() {
      this.setupContainer();
    },

    mounted() {
      this.showNotice(), i.on("toast-clear", this.dismiss);
    },

    methods: {
      setupContainer() {
        if (this.parentTop = document.querySelector(".v-toast.v-toast--top"), this.parentBottom = document.querySelector(".v-toast.v-toast--bottom"), this.parentTop && this.parentBottom) return;
        this.parentTop || (this.parentTop = document.createElement("div"), this.parentTop.className = "v-toast v-toast--top"), this.parentBottom || (this.parentBottom = document.createElement("div"), this.parentBottom.className = "v-toast v-toast--bottom");
        const t = document.body;
        t.appendChild(this.parentTop), t.appendChild(this.parentBottom);
      },

      shouldQueue() {
        return !!this.queue && (this.parentTop.childElementCount > 0 || this.parentBottom.childElementCount > 0);
      },

      dismiss() {
        this.timer && this.timer.stop(), clearTimeout(this.queueTimer), this.isActive = !1, setTimeout(() => {
          var t;
          this.onDismiss.apply(null, arguments), this.$destroy(), void 0 !== (t = this.$el).remove ? t.remove() : t.parentNode.removeChild(t);
        }, 150);
      },

      showNotice() {
        this.shouldQueue() ? this.queueTimer = setTimeout(this.showNotice, 250) : (this.correctParent.insertAdjacentElement("afterbegin", this.$el), this.isActive = !0, this.duration && (this.timer = new s(this.dismiss, this.duration)));
      },

      whenClicked() {
        this.dismissible && (this.onClick.apply(null, arguments), this.dismiss());
      },

      toggleTimer(t) {
        this.pauseOnHover && this.timer && (t ? this.timer.pause() : this.timer.resume());
      }

    },
    computed: {
      correctParent() {
        switch (this.position) {
          case o.TOP:
          case o.TOP_RIGHT:
          case o.TOP_LEFT:
            return this.parentTop;

          case o.BOTTOM:
          case o.BOTTOM_RIGHT:
          case o.BOTTOM_LEFT:
            return this.parentBottom;
        }
      },

      transition() {
        switch (this.position) {
          case o.TOP:
          case o.TOP_RIGHT:
          case o.TOP_LEFT:
            return {
              enter: "v-toast--fade-in-down",
              leave: "v-toast--fade-out"
            };

          case o.BOTTOM:
          case o.BOTTOM_RIGHT:
          case o.BOTTOM_LEFT:
            return {
              enter: "v-toast--fade-in-up",
              leave: "v-toast--fade-out"
            };
        }
      }

    },

    beforeDestroy() {
      i.off("toast-clear", this.dismiss);
    }

  }, function () {
    var t = this,
        e = t._self._c;
    return e("transition", {
      attrs: {
        "enter-active-class": t.transition.enter,
        "leave-active-class": t.transition.leave
      }
    }, [e("div", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: t.isActive,
        expression: "isActive"
      }],
      staticClass: "v-toast__item",
      class: ["v-toast__item--".concat(t.type), "v-toast__item--".concat(t.position)],
      attrs: {
        role: "alert"
      },
      on: {
        mouseover: function (e) {
          return t.toggleTimer(!0);
        },
        mouseleave: function (e) {
          return t.toggleTimer(!1);
        },
        click: t.whenClicked
      }
    }, [e("div", {
      staticClass: "v-toast__icon"
    }), t._v(" "), e("p", {
      staticClass: "v-toast__text",
      domProps: {
        innerHTML: t._s(t.message)
      }
    })])]);
  }, [], !1, null, null, null);

  const r = a.exports,
        c = function (t) {
    let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return {
      open(s) {
        let o;
        "string" == typeof s && (o = s);
        const i = {
          message: o
        },
              n = Object.assign({}, i, e, s);
        return new (t.extend(r))({
          el: document.createElement("div"),
          propsData: n
        });
      },

      clear() {
        i.emit("toast-clear");
      },

      success(t) {
        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return this.open(Object.assign({}, {
          message: t,
          type: "success"
        }, e));
      },

      error(t) {
        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return this.open(Object.assign({}, {
          message: t,
          type: "error"
        }, e));
      },

      info(t) {
        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return this.open(Object.assign({}, {
          message: t,
          type: "info"
        }, e));
      },

      warning(t) {
        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return this.open(Object.assign({}, {
          message: t,
          type: "warning"
        }, e));
      },

      default(t) {
        let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return this.open(Object.assign({}, {
          message: t,
          type: "default"
        }, e));
      }

    };
  };

  r.install = function (t) {
    let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        s = c(t, e);
    t.$toast = s, t.prototype.$toast = s;
  };

  const l = r;
  return e = e.default;
})());